import React from "react";
import { t } from "i18next";
import { UTILS } from "utils";

const ErrorComponent = ({ error }) => {
  UTILS.logErrorOnSentry(error, "info");
  if (
    typeof error === "string" &&
    (error.includes("null") || error.includes("undefined"))
  ) {
    return (
      <div className="">
        <div className="text-red-500 text-center font-bold mt-3 mb-3">
          {t("Something was incorrect.")}
        </div>
      </div>
    );
  } else if (error === null || error === undefined) {
    return null;
  } else {
    return (
      <div className="">
        <div className="text-red-500 text-center font-bold mt-3 mb-3 px-4">
          {typeof error === "string" ? error : t("Something was incorrect.")}
        </div>
      </div>
    );
  }
};

export const Alert = ({ type = "warning", title, message }) => {
  const styles = {
    warning: {
      bg: "bg-yellow-50",
      text: "text-yellow-800 ",
      iconColor: "text-yellow-400",
    },
    info: {
      bg: "bg-blue-50",
      text: "text-blue-800",
      iconColor: "text-blue-400",
    },
    success: {
      bg: "bg-green-50",
      text: "text-green-800",
      iconColor: "text-green-400",
    },
    error: {
      bg: "bg-red-50",
      text: "text-red-800",
      iconColor: "text-red-400",
    },
  };

  const { bg, text } = styles[type] || styles.warning;

  return (
    <div
      className={`flex items-center p-4 text-sm rounded-lg ${bg} ${text}`}
      role="alert"
    >
      <svg
        className="shrink-0 inline w-4 h-4 me-3"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
      </svg>
      <div>
        <span className="font-medium">{title}</span> {message}
      </div>
    </div>
  );
};


export default ErrorComponent;
